module.exports = {
  s: {
    key: 's',
    label: 'Second',
  },
  min: {
    key: 'min',
    label: 'Minute',
  },
  h: {
    key: 'h',
    label: 'Hour',
  },
  d: {
    key: 'd',
    label: 'Day',
  },
  wk: {
    key: 'wk',
    label: 'Week',
  },
  mo: {
    key: 'mo',
    label: 'Month',
  },
  a: {
    key: 'a',
    label: 'Year',
  },
};